import { z } from "zod";

export const PaymentMethodDto = z.object({
  type: z.string(),
  last4: z.string(),
  brand: z.string().optional(),
  expMonth: z.number().optional(),
  expYear: z.number().optional(),
}).nullable();

export const BillingInfoDto = z.object({
  name: z.string().nullable(),
  email: z.string().nullable(),
  address: z.string().nullable(),
  taxId: z.string().nullable(),
});

export const RecentInvoiceDto = z.object({
  id: z.string(),
  amount: z.number(),
  currency: z.string(),
  status: z.string(),
  date: z.string().transform((date) => new Date(date)),
  url: z.string().nullable(),
  description: z.string().nullable().optional(),
});

export const DetailedSubscriptionDto = z.object({
  subscription: z.object({
    id: z.string(),
    status: z.string(),
    currentPeriodStart: z.string().transform((date) => new Date(date)),
    currentPeriodEnd: z.string().transform((date) => new Date(date)),
    cancelAt: z.string().transform((date) => new Date(date)).nullable(),
  }),
  plan: z.object({
    name: z.string(),
    amount: z.number(),
    currency: z.string(),
    interval: z.string(),
    features: z.array(z.string()),
  }),
});

/** The customer's billing details, card and invoices, whatever they paid for. */
export const CustomerBillingDto = z.object({
  paymentMethod: PaymentMethodDto,
  billing: BillingInfoDto,
  recentInvoices: z.array(RecentInvoiceDto),
});

export type PaymentMethodDto = z.infer<typeof PaymentMethodDto>;
export type BillingInfoDto = z.infer<typeof BillingInfoDto>;
export type RecentInvoiceDto = z.infer<typeof RecentInvoiceDto>;
export type DetailedSubscriptionDto = z.infer<typeof DetailedSubscriptionDto>;
export type CustomerBillingDto = z.infer<typeof CustomerBillingDto>;
